// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lineTimetable_timetableDays_eP1uR {
  margin: 0 1rem 1rem 1.2rem;
  font-size: 0.8em;
  font-family: GothamRounded-Book;
  word-wrap: break-word;
}

.lineTimetable_timetableDates_o1aUu {
  margin: 0 1rem 1rem 2rem;
  font-size: 0.8em;
  font-family: GothamRounded-Book;
}

.lineTimetable_footnote_WXlqK {
  padding: 0.125em 0.625em;
  font-family: GothamRounded-Book;
  font-size: 0.813em;
}

.lineTimetable_pageBreak_wwsaz {
  break-inside: auto;
}

.lineTimetable_timetableDivider_QRYq8 {
  margin-top: 1rem;
  width: 100%;
  border-bottom: 2px dotted gray;
}

.lineTimetable_timetableContainer_YWt3K {
  display: block;
}

.lineTimetable_fridayNote_Vd07j {
  margin-left: 1.5rem;
  font-family: GothamRounded-Book;
  font-size: 12px;
}

.lineTimetable_notesContainer_MKtJC {
  margin: 0.5rem 0 1rem 0.5rem;
}

.lineTimetable_pageNumber_NsKBu {
  font-family: GothamRounded-Medium;
  font-size: 16px;
  color: black;
  position: absolute;
  left: 680px;
  right: 30px;
  width: fit-content;
  height: fit-content;
}

.lineTimetable_printBtnContainer_qPRWU {
  position: absolute;
  left: 680px;
  top: 20px;
}

@media print {
  .lineTimetable_noPrint_k_cbr,
  .lineTimetable_noPrint_k_cbr * {
    display: none !important;
  }

  .lineTimetable_timetableContainer_YWt3K,
  .lineTimetable_timetableContainer_YWt3K * {
    break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/lineTimetable/lineTimetable.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":[".timetableDays {\n  margin: 0 1rem 1rem 1.2rem;\n  font-size: 0.8em;\n  font-family: GothamRounded-Book;\n  word-wrap: break-word;\n}\n\n.timetableDates {\n  margin: 0 1rem 1rem 2rem;\n  font-size: 0.8em;\n  font-family: GothamRounded-Book;\n}\n\n.footnote {\n  padding: 0.125em 0.625em;\n  font-family: GothamRounded-Book;\n  font-size: 0.813em;\n}\n\n.pageBreak {\n  break-inside: auto;\n}\n\n.timetableDivider {\n  margin-top: 1rem;\n  width: 100%;\n  border-bottom: 2px dotted gray;\n}\n\n.timetableContainer {\n  display: block;\n}\n\n.fridayNote {\n  margin-left: 1.5rem;\n  font-family: GothamRounded-Book;\n  font-size: 12px;\n}\n\n.notesContainer {\n  margin: 0.5rem 0 1rem 0.5rem;\n}\n\n.pageNumber {\n  font-family: GothamRounded-Medium;\n  font-size: 16px;\n  color: black;\n  position: absolute;\n  left: 680px;\n  right: 30px;\n  width: fit-content;\n  height: fit-content;\n}\n\n.printBtnContainer {\n  position: absolute;\n  left: 680px;\n  top: 20px;\n}\n\n@media print {\n  .noPrint,\n  .noPrint * {\n    display: none !important;\n  }\n\n  .timetableContainer,\n  .timetableContainer * {\n    break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timetableDays": `lineTimetable_timetableDays_eP1uR`,
	"timetableDates": `lineTimetable_timetableDates_o1aUu`,
	"footnote": `lineTimetable_footnote_WXlqK`,
	"pageBreak": `lineTimetable_pageBreak_wwsaz`,
	"timetableDivider": `lineTimetable_timetableDivider_QRYq8`,
	"timetableContainer": `lineTimetable_timetableContainer_YWt3K`,
	"fridayNote": `lineTimetable_fridayNote_Vd07j`,
	"notesContainer": `lineTimetable_notesContainer_MKtJC`,
	"pageNumber": `lineTimetable_pageNumber_NsKBu`,
	"printBtnContainer": `lineTimetable_printBtnContainer_qPRWU`,
	"noPrint": `lineTimetable_noPrint_k_cbr`
};
module.exports = ___CSS_LOADER_EXPORT___;
